/* unplugin-vue-components disabled */import { render } from "./commands-mobile.vue?vue&type=template&id=38a54001"
import script from "./commands-mobile.vue?vue&type=script&lang=js"
export * from "./commands-mobile.vue?vue&type=script&lang=js"

import "./commands-mobile.vue?vue&type=style&index=0&id=38a54001&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat-input-v2/commands-menu/commands-mobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38a54001"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38a54001', __exports__)) {
    api.reload('38a54001', __exports__)
  }
  
  module.hot.accept("./commands-mobile.vue?vue&type=template&id=38a54001", () => {
    api.rerender('38a54001', render)
  })

}


export default __exports__